import type { FormikProps } from "formik";
import { Formik } from "formik";
import type { ReactNode } from "react";
import React from "react";
import { FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button } from "~/components/common/parts/button/Button";
import { FormGroup } from "~/components/common/parts/form/FormGroup";
import { useSessions } from "~/hooks/vendors/useSessions";
import type { VendorUser } from "~/models/VendorUser";
import { isSuccess } from "~/utils/api/api_handler";
import { updateSelf } from "~/utils/api/vendors/VendorUser";
import SettingStyles from "../SettingStyle.module.scss";

type VendorUserProperty = Record<string, string | number | boolean>;

const isChanged = (
	base: VendorUserProperty,
	target: VendorUserProperty
): boolean => Object.keys(base).some((key) => base[key] !== target[key]);

export const ProfileSettingVendorUser: React.FC = () => {
	const { data: session, mutate: mutateSession } = useSessions().index();
	const handleSave = async (submitValue: VendorUser): Promise<void> => {
		const result = await updateSelf(submitValue);
		if (isSuccess(result)) {
			await mutateSession?.();
			toast.success("保存しました");
			return;
		}
		toast.error(`エラーが発生しました。${result.message}`);
	};
	const initialVendorUser = React.useMemo(() => {
		if (session === null) {
			return null;
		}
		return session.vendorUser;
	}, [session]);
	if (initialVendorUser === null) {
		return null;
	}
	return (
		<div className={SettingStyles.SettingBlock}>
			<Formik initialValues={initialVendorUser} onSubmit={handleSave}>
				{({
					values,
					handleChange,
					handleBlur,
					handleSubmit
				}: FormikProps<VendorUser>): ReactNode => (
					<div className={SettingStyles.MiddleSizeBlock}>
						<FormGroup>
							<label className={SettingStyles.NoBackgroundLabel}>氏名</label>
							<FormControl
								name="name"
								onBlur={handleBlur}
								onChange={handleChange}
								type="text"
								value={values.name}
							/>
						</FormGroup>
						<FormGroup>
							<label className={SettingStyles.NoBackgroundLabel}>
								メールアドレス
							</label>
							<FormControl
								name="email"
								onBlur={handleBlur}
								onChange={handleChange}
								type="text"
								value={values.email}
							/>
						</FormGroup>
						<FormGroup>
							<label className={SettingStyles.NoBackgroundLabel}>
								電話番号
							</label>
							<FormControl
								name="tel"
								onBlur={handleBlur}
								onChange={handleChange}
								type="text"
								value={values.tel}
							/>
						</FormGroup>
						<Button
							className={SettingStyles.SettingSubmitButton}
							disabled={!isChanged(initialVendorUser, values)}
							onClick={handleSubmit}
							round
							variant="black_primary"
						>
							変更内容を保存
						</Button>
					</div>
				)}
			</Formik>
		</div>
	);
};
